import React from 'react';
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';
import { useTheme, Box, Text, Flex } from '@chakra-ui/react';
import CustomTooltip from '../UI/CustomTooltip'; 

const ClientStatusChart = ({ data }) => {
    
    const statusData = data || []; 

    const totalClientes = statusData.reduce((sum, entry) => sum + (entry.value || 0), 0);
    
    const theme = useTheme();

    if (!statusData || statusData.length === 0) {
        return (
            <Flex justify="center" align="center" h="100%">
                <Text color="gray.500">Nenhum dado de status de cliente disponível.</Text>
            </Flex>
        );
    }
    
    const NEON_COLOR = 'green.400';
    const CHART_SHADOW = `drop-shadow(0 0 5px rgba(52, 211, 103, 0.5))`; // Shadow Verde Neon
    const LEGEND_COLOR = 'gray.400';

    return (
        <Box 
            position="relative" 
            w="100%" 
            h="100%" 
        >
            <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                    <Pie
                        data={statusData}
                        cx="50%" 
                        cy="55%" 
                        innerRadius={60} 
                        outerRadius={100}
                        paddingAngle={statusData.length > 1 ? 5 : 0}
                        dataKey="value"
                        nameKey="name"
                        stroke="none"
                        labelLine={false}
                        style={{ filter: CHART_SHADOW }} 
                    >
                        {statusData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} /> 
                        ))}
                    </Pie>
                    
                    <Tooltip 
                        content={<CustomTooltip format="number" />} 
                        wrapperStyle={{ zIndex: 100 }} 
                    />
                    
                    <Legend 
                        layout="horizontal"           
                        verticalAlign="bottom"        
                        align="center"                
                        iconType="circle"
                        wrapperStyle={{ 
                            fontSize: '12px', 
                            color: LEGEND_COLOR, 
                            paddingTop: '20px' 
                        }}
                    />
                </PieChart>
            </ResponsiveContainer>

            <Box
                position="absolute"
                top="45%" 
                left="50%"
                transform="translate(-50%, -50%)" 
                textAlign="center"
                pointerEvents="none" 
                zIndex={2} 
            >
                <Text 
                    fontSize="2xl" 
                    fontWeight="bold" 
                    color={NEON_COLOR} 
                >
                    {totalClientes.toLocaleString('pt-BR')}
                </Text>
                <Text fontSize="xs" color="gray.400">
                    Total Clientes
                </Text>
            </Box>
        </Box>
    );
};

export default ClientStatusChart;